// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Guest360OutlinedSvg from "@fishx/icons-svg/es/asn/Guest360Outlined";
import FishxIcon from '../components/FishxIcon';

var Guest360Outlined = function Guest360Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Guest360OutlinedSvg
  }));
};

Guest360Outlined.displayName = 'Guest360Outlined';
export default React.forwardRef(Guest360Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Guest360Outlined.js
// module id = 2908
// module chunks = 0